import { MODAL_CHANGE } from "../actions";

export function showModal(open, children) {
  return { type: MODAL_CHANGE, payload: {open, children} };
}
